module.exports = __webpack_public_path__ + "static/img/RAPD-1U305-B_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPD-1U305-B_1.png
// module id = TPQB
// module chunks = 0